import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { UserView } from '../../models/business/user/user-view';
import { mockEnvironment } from '@shared/models/project-constant/constant';
import { JobProcess } from '../../models/types/job_process';
@Injectable()
export class UserService {
  public token: string;

  constructor(private http: HttpClient) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.token = currentUser && currentUser.token;
  }

  getJobprocess() {
    return this.http.get<JobProcess>(`${environment.api}job_process`)
  }

  getAllUser() {
    return this.http.get(`${environment.api}users/1`);
  }
  getAllUsersWithDesignation() {
    return this.http.get(`${environment.api}usersWithDesignation`);
  }
  addUser(insertData) {
    return this.http.post(`${environment.api}user`, insertData);
  }
  updateUser(updateData) {
    return this.http.put(`${environment.api}user/` + updateData.user_id, updateData);
  }
  changepass(passData) {
    return this.http.post(`${environment.api}user/changepass`, passData);
  }
  checkpass(passData) {
    return this.http.post(`${environment.api}user/checkoldpass`, passData);
  }
  blockUnblockUser(passData) {
    return this.http.post(`${environment.api}user/block`, passData);
  }
  getRecordManagers(type) {
    return this.http.post(`${environment.api}record_mgr/list`, { 'type': type });
  }
  getUserLogs(passData) {

    return this.http.post(`${environment.api}user_logs`, passData);
  }
  getUserLogCount(passData) {

    return this.http.post(`${environment.api}user_logs/count`, passData);
  }
  addUserLog(insertData) {
    return this.http.post(`${environment.api}user_logs/insert`, insertData);
  }
  getBusinessName(dtls) {
    return this.http.post(`${environment.api}user_logs/business_name`, dtls);
  }
  getBusinessId(dtls) {
    return this.http.post(`${environment.api}user_logs/business_id`, dtls);
  }

  /*** Reports services ***/
  //Detailed report for opportunities
  getOpportunitiesWithAllData(ids){
    return this.http.post(`${environment.api}report/getOpportunitiesWithAllData`, ids)        
  }



  //Report by Sales
  getReportBySales(data) {
    return this.http.post(`${environment.api}report/report_by_sales`, data)
  }
  //Report by Sales - Detailed
  getDetailedReportBySales(data) {
    return this.http.post(`${environment.api}report/report_by_sales_detailed`, data)
  }

  //Report by potential sales
  getReportByPotentialSales(data) {
    return this.http.post(`${environment.api}report/report_by_potential_sales`, data)
  }
  //Report by Sales - Detailed
  getDetailedReportByPotentialSales(data) {
    return this.http.post(`${environment.api}report/report_by_potential_sales_detailed`, data)
  }

  //Report by potential sales
  getReferredOpportunities(data) {
    return this.http.post(`${environment.api}report/report_for_referred_opportunities`, data)
  }

  //Professsionals list
  getListOfProfessionals(data) {
    return this.http.post(`${environment.api}report/professionals_list`, data)
  }

  getDefaultReport(data) {
    return this.http.post(`${environment.api}report/defaultReport`, data)
  }

  getOpenOpportunities(data) {
    return this.http.post(`${environment.api}report/opportunitiesbasedonactivity`, data)
  }

  //Report for Opportunities by Status - Detailed
  getDetailedReportByOpportunityStatus(data) {
    return this.http.post(`${environment.api}report/report_by_opportunity_status_detailed`, data)
  }

  //Report for Opportunities by Status - Detailed
  getUserActivitiesReport(data) {
    return this.http.post(`${environment.api}report/report_for_user_activity`, data)
  }

  //Report by Sales
  getReportByArea(data) {
    return this.http.post(`${environment.api}report/report_by_area`, data)
  }
  
  //Report for commissions paid/due
  getReportByCommission(data) {
    return this.http.post(`${environment.api}report/report_by_comissions`, data)
  }


  //Dashboard Services

  getUserSales(q) {
    return this.http.post(`${environment.api}graphicalreport/graphforusersales`, q)
  }

  getPotentialSales(q) {
    return this.http.post(`${environment.api}graphicalreport/graphforpotentialsales`, q)
  }

  getOpportunities(q) {
    return this.http.post(`${environment.api}graphicalreport/graphforopportunities`, q)
  }

  getNewOpportunities(q) {
    return this.http.post(`${environment.api}graphicalreport/graphfornewopportunities`, q)
  }

  getActivities(q) {
    return this.http.post(`${environment.api}graphicalreport/graphforactivities`, q)
  }

  getClientAccessDetails(data) {
    return this.http.post(`${environment.api}report/report_for_client_access_details`, data)
  }

  getFileAccessDetails(data) {
    return this.http.post(`${environment.api}report/report_for_file_access_details`, data)
  }
  
  changeContactStatus(data) {
    return this.http.post(`${environment.api}report/changecontactstatus`, data)
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/user/user.service.ts